<template>
    <div>
        <div class="content-caption dashed ">
            <span>调整单信息</span>
        </div>
        <el-form :model="deprAdjustVoucher" :rules="rulesInfo" ref="ruleForm" class="demo-ruleForm">
            <div class="simple-form flex col-2">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">标题</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="title">
                            <el-input type="text" v-model="deprAdjustVoucher.title" placeholder="请输入标题"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="deprAdjustVoucher.adjustType != 0">
                    <div class="form-label">
                        <label class="required">调整内容</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="adjustType">
                            <el-radio-group v-model="deprAdjustVoucher.adjustType" @change="changeAdjustType" :disabled="(deprAdjustVoucher.purchReceiptId != null && deprAdjustVoucher.purchReceiptId != -1) || readyAdjust">
                                <el-radio :label="1">原值</el-radio>
                                <el-radio :label="2">累计折旧</el-radio>
                                <el-radio v-if="deprAdjustVoucher.purchReceiptId != null && deprAdjustVoucher.purchReceiptId != -1" :label="3">含税价</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="!readyAdjust && deprAdjustVoucher.adjustType == 1 && (receiptId == null || receiptId == -1)">
                    <div class="form-label">
                        <label class="required">原值冲销</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="adjustType">
                            <el-radio-group v-model="deprAdjustVoucher.orgWorthRevoke" @change="changeOrgWorthRevoke" :disabled="deprAdjustVoucher.purchReceiptId != null && deprAdjustVoucher.purchReceiptId != -1">
                                <el-radio :label="true">是</el-radio>
                                <el-radio :label="false">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="deprAdjustVoucher.adjustType == 1 || deprAdjustVoucher.adjustType == 3">
                    <div class="form-label">
                        <label class="required">需要验收结算</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="settleNeeded">
                            <el-radio-group class="width-1-5x" v-model="deprAdjustVoucher.settleNeeded" @change="changeSettleNeeded"
                                            :disabled="readyAdjust || (deprAdjustVoucher.purchReceiptId != null && deprAdjustVoucher.purchReceiptId != -1) || deprAdjustVoucher.orgWorthRevoke || deprAdjustVoucher.adjustType == 3">
                                <el-radio :label="true">需要</el-radio>
                                <el-radio :label="false">不需要</el-radio>
                            </el-radio-group>
                            <div class="input-tip error">需结算的只能调增，不可调减</div>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="deprAdjustVoucher.settleNeeded">
                    <div class="form-label">
                        <label class="required">业务单元</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="retailerBizUnitId">
                            <el-input class="width-1-5x bottom-line" :disabled="true" v-model="deprAdjustVoucher.retailerBizUnitName"></el-input>
                            <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="selectBizUnit" v-if="(deprAdjustVoucher.purchReceiptId == null || deprAdjustVoucher.purchReceiptId == -1) && !readyAdjust"></i>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="deprAdjustVoucher.settleNeeded && deprAdjustVoucher.adjustType != 3">
                    <div class="form-label">
                        <label class="required">调整方式</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="settleTaxOffset">
                            <el-radio-group class="width-1x" v-model="deprAdjustVoucher.settleTaxOffset" :disabled="receiptId || readyAdjust" @change="changeSettleTaxOffset">
                                <el-radio :label="true">未税</el-radio>
                                <el-radio :label="false">含税</el-radio>
                            </el-radio-group>
                            <div class="input-tip error">根据结算发票类型是否可抵扣，确定输入金额</div>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="deprAdjustVoucher.settleNeeded">
                    <div class="form-label">
                        <label class="required">供应商标识</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="settlePeerId">
                            <el-input class="width-1-5x bottom-line" :disabled="true" v-model="deprAdjustVoucher.sellerInnerCode"></el-input>
                            <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="selectSeller" v-if="(deprAdjustVoucher.purchReceiptId == null || deprAdjustVoucher.purchReceiptId == -1) && !readyAdjust"></i>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="deprAdjustVoucher.settleNeeded">
                    <div class="form-label">
                        <label class="required">结算税率</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="settleTaxRate">
                            <el-select class="width-1x" v-model="deprAdjustVoucher.settleTaxRate" placeholder="请选择税率" clearable @change="changeSettleTaxRate">
                                <el-option v-for="item in fiscalTaxMarkList" :key="item.rate" :label="item.rate" :value="item.rate"></el-option>
                            </el-select>
                            <span>%</span>
                            <div class="input-tip error">为空时使用资产默认税率</div>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>备注</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="memo">
                            <el-input type="textarea" :rows="2" placeholder="请输入说明" v-model="deprAdjustVoucher.memo"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <div class="simple-form label">
                <div class="form-group center">
                    <div class="form-value">
                        <div class="inline-block mr5">
                            <el-form-item>
                                <el-checkbox v-model="autoApply">自动申请</el-checkbox>
                            </el-form-item>
                        </div>
                        <div class="inline-block mr5" v-if="autoApply">
                            <el-form-item>
                                <el-checkbox v-model="autoAuditPass">自动审核</el-checkbox>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </div>
        </el-form>
        <div class="content-caption dashed">
            <span>资产信息</span>
            <div class="input-tip error" v-if="!readyAdjust && deviceXId == null && voucherId == null || (voucherId != null && bizVoucherType == null)">
                <span>提示:一次调整数据最多500条</span>
            </div>
        </div>
        <div class="simple-row" v-if="!readyAdjust && deviceXId == null && voucherId == null || (voucherId != null && bizVoucherType == null)">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="showDeviceListDlg()" v-if="deprAdjustVoucher.purchReceiptId == null || deprAdjustVoucher.purchReceiptId == -1">
                    <span>选择资产</span>
                </button>
            </div>
            <div class="right">
                <button class="swb-btn swb-btn-small" @click="batchOrgWorthUpdate" v-if="deprAdjustVoucher.adjustType != 0 && deprAdjustVoucher.adjustType != 3 && !deprAdjustVoucher.orgWorthRevoke">
                    <span>批量调整金额</span>
                </button>
                <button class="swb-btn swb-btn-small" @click="batchWtxPriceUpdate" v-if="deprAdjustVoucher.adjustType == 3">
                    <span>批量调整金额</span>
                </button>
            </div>
        </div>
        <div class="table-layout">
            <div class="right-toolbar mb5 fr">
                <span v-if="deprAdjustVoucher.itemList != null">已选择({{ deprAdjustVoucher.itemList.length }})</span>
            </div>
            <el-form :model="deprAdjustVoucher" ref="deviceInfo">
                <template v-if="deprAdjustVoucher.adjustType == 0">
                    <el-table :data="deprAdjustVoucher.itemList" border maxHeight="500">
                        <el-table-column prop="devcInnerCode" width="180" label="资产编号" align="left" fixed show-overflow-tooltip></el-table-column>
                        <el-table-column prop="retailerComFullName" width="180" label="部门全称" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="title" width="180" label="资产描述全称" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="name" width="180" label="名称" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="model" width="150" label="型号" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="fixedSpec" width="150" label="规格" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="tmpNo" width="150" label="系统编号" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="innerDevcBrandName" width="150" label="资产品牌" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="assetKindName" width="150" label="财务类别" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="quantity" width="100" label="数量" align="right" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="theUnit" width="100" label="单位" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="deprMethodCode" width="100" label="折旧算法" align="left" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ deprMethodCodeMap[rows.row.deprMethodCode] }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ntxPrice" width="140" label="调整前未税价(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ (rows.row.ntxPrice || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ntxPrice2" width="140" label="调整后未税价(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.ntxPrice2 != null">{{ (rows.row.ntxPrice2 || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="taxPrice" width="140" label="调整前进项税额(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ (rows.row.taxPrice || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="taxPrice2" width="140" label="调整后进项税额(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.taxPrice2 != null">{{ (rows.row.taxPrice2 || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="taxRate" width="140" label="调整前进项税率(%)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ (rows.row.taxRate || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="taxRate2" width="140" label="调整后进项税率(%)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.taxRate2 != null">{{ (parseFloat(rows.row.taxRate2) || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="orgWorth" width="140" label="调整前资产原值(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span v-if="rows.row.orgWorth != null">{{ (rows.row.orgWorth || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="orgWorth2" width="140" label="调整后资产原值(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.orgWorth2 != null">{{ (rows.row.orgWorth2 || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="netWorth" width="140" label="调整前净值(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span v-if="rows.row.netWorth != null">{{ (rows.row.netWorth || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="netWorth2" width="140" label="调整后净值(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.netWorth2 != null">{{ rows.row.netWorth2.toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="deprWorth" width="140" label="调整前近期折旧(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span v-if="rows.row.deprWorth != null">{{ (rows.row.deprWorth || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="deprWorth2" width="140" label="调整后近期折旧(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.deprWorth2 != null">{{ (rows.row.deprWorth2 || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="durableLife" width="140" label="调整前使用年限(月)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ rows.row.durableLife }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="durableLife2" width="140" label="调整后使用年限(月)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.deprWorth2 != null">{{ rows.row.durableLife2 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="onsetDate" width="140" label="调整前起算日期" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ rows.row.onsetDate }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="onsetDate2" width="140" label="调整后起算日期" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.onsetDate2 != null">{{ rows.row.onsetDate2 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="rmnWorthRatio" width="140" label="调整前残值率(%)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ (rows.row.rmnWorthRatio || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="rmnWorthRatio2" width="140" label="调整后残值率(%)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.rmnWorthRatio2 != null">{{ rows.row.rmnWorthRatio2.toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="aggtDeprWorth" width="140" label="调整前累计折旧(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span v-if="rows.row.aggtDeprWorth != null">{{ (rows.row.aggtDeprWorth || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="aggtDeprWorth2" width="140" label="调整后累计折旧(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.aggtDeprWorth2 != null">{{ rows.row.aggtDeprWorth2.toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="deprMonth" width="100" label="折旧月份" align="right" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="taxOffset" width="100" label="是否抵扣" align="center" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ rows.row.taxOffset ? '是' : '否' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="deprOver" width="100" label="折旧完毕" align="center" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ rows.row.deprOver ? '是' : '否' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="assetType" width="100" label="管理方式" align="center" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ rows.row.assetType == 0 ? '单品式管理' : '批量式管理' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" width="120" label="操作" show-overflow-tooltip fixed="right"
                                         v-if="deprAdjustVoucher.adjustType == 0 || (deprAdjustVoucher.purchReceiptId != null && deprAdjustVoucher.purchReceiptId != -1)">
                            <template slot-scope="scope">
                                <a class="swb-btn-link" v-if="deprAdjustVoucher.purchReceiptId == null || deprAdjustVoucher.purchReceiptId == -1" @click="updateDepr(scope.row, scope.$index)">调整</a>
                                <a class="swb-btn-link" v-if="deviceXId == null && voucherId == null || (voucherId != null && bizVoucherType == null)" @click="deleteDevc(scope.$index)">移除</a>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <template v-if="deprAdjustVoucher.adjustType == 1">
                    <el-table :data="deprAdjustVoucher.itemList" border maxHeight="500">
                        <el-table-column prop="devcInnerCode" width="180" label="资产编号" align="left" fixed show-overflow-tooltip></el-table-column>
                        <el-table-column prop="retailerComFullName" width="180" label="部门全称" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="title" width="180" label="资产描述全称" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="name" width="180" label="名称" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="model" width="150" label="型号" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="fixedSpec" width="150" label="规格" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="tmpNo" width="150" label="系统编号" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="innerDevcBrandName" width="150" label="资产品牌" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="assetKindName" width="150" label="财务类别" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="quantity" width="100" label="数量" align="right" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="theUnit" width="100" label="单位" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="deprMethodCode" width="100" label="折旧算法" align="left" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ deprMethodCodeMap[rows.row.deprMethodCode] }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="taxPrice" width="140" label="调整前进项税额(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ (rows.row.taxPrice || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="taxPrice2" width="140" label="调整后进项税额(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.taxPrice2 != null">{{ (rows.row.taxPrice2 || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="taxRate" width="140" label="调整前进项税率(%)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ (rows.row.taxRate || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="taxRate2" width="140" label="调整后进项税率(%)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.taxRate2 != null">{{ (parseFloat(rows.row.taxRate2) || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="orgWorth" width="140" label="调整前资产原值(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span v-if="rows.row.orgWorth != null">{{ (rows.row.orgWorth || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="orgWorth" width="140" label="原值调整金额(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <input v-if="rows.row.orgWorth2 != null && rows.row.orgWorth != null" class="align-right" style="width: 100%" type="number" size="4" @change="((event)=>{changeOrgWorth2(event, rows.row)})"
                                       :value="parseFloat((rows.row.orgWorth2 - rows.row.orgWorth).toFixed(2))" :disabled="deprAdjustVoucher.orgWorthRevoke || readyAdjust"/>
                                <input class="align-right" :disabled="readyAdjust" style="width: 100%" type="number" size="4" @change="((event)=>{changeOrgWorth2(event, rows.row)})" v-else/>
                            </template>
                        </el-table-column>
                        <el-table-column prop="orgWorth2" width="140" label="调整后资产原值(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.orgWorth2 != null">{{ (rows.row.orgWorth2 || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="netWorth" width="140" label="调整前净值(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span v-if="rows.row.netWorth != null">{{ (rows.row.netWorth || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="netWorth2" width="140" label="调整后净值(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.netWorth2 != null">{{ rows.row.netWorth2.toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="deprMonth" width="100" label="折旧月份" align="right" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="taxOffset" width="100" label="是否抵扣" align="center" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ rows.row.taxOffset ? '是' : '否' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="deprOver" width="100" label="折旧完毕" align="center" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ rows.row.deprOver ? '是' : '否' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="assetType" width="100" label="管理方式" align="center" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ rows.row.assetType == 0 ? '单品式管理' : '批量式管理' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" width="150" label="操作" show-overflow-tooltip fixed="right"
                                         v-if="!readyAdjust && (deprAdjustVoucher.adjustType == 1 || (deprAdjustVoucher.purchReceiptId != null && deprAdjustVoucher.purchReceiptId != -1))">
                            <template slot-scope="scope">
                                <a class="swb-btn-link" v-if="deprAdjustVoucher.adjustType == 0 && (deprAdjustVoucher.purchReceiptId == null || deprAdjustVoucher.purchReceiptId == -1)" @click="updateDepr(scope.row, scope.$index)">调整</a>
                                <a class="swb-btn-link" v-if="deviceXId == null && voucherId == null || (voucherId != null && bizVoucherType == null)" @click="deleteDevc(scope.$index)">移除</a>
                                <a class="swb-btn-link" v-if="deprAdjustVoucher.settleNeeded && deprAdjustVoucher.settleTaxOffset && (deprAdjustVoucher.purchReceiptId == null || deprAdjustVoucher.purchReceiptId == -1)"
                                   @click="calculationOrgWorthDlg(scope.row)">按含税调整</a>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <template v-if="deprAdjustVoucher.adjustType == 2">
                    <el-table :data="deprAdjustVoucher.itemList" border maxHeight="500">
                        <el-table-column prop="devcInnerCode" width="180" label="资产编号" align="left" fixed show-overflow-tooltip></el-table-column>
                        <el-table-column prop="retailerComFullName" width="180" label="部门全称" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="title" width="180" label="资产描述全称" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="name" width="180" label="名称" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="model" width="150" label="型号" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="fixedSpec" width="150" label="规格" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="tmpNo" width="150" label="系统编号" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="innerDevcBrandName" width="150" label="资产品牌" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="assetKindName" width="150" label="财务类别" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="quantity" width="100" label="数量" align="right" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="theUnit" width="100" label="单位" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="deprMethodCode" width="100" label="折旧算法" align="left" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ deprMethodCodeMap[rows.row.deprMethodCode] }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="orgWorth" width="140" label="调整前资产原值(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span v-if="rows.row.orgWorth != null">{{ (rows.row.orgWorth || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="netWorth" width="140" label="调整前净值(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span v-if="rows.row.netWorth != null">{{ (rows.row.netWorth || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="netWorth2" width="140" label="调整后净值(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.netWorth2 != null">{{ rows.row.netWorth2.toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="deprWorth" width="140" label="调整前近期折旧(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span v-if="rows.row.deprWorth != null">{{ (rows.row.deprWorth || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="deprWorth2" width="140" label="调整后近期折旧(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.deprWorth2 != null">{{ (rows.row.deprWorth2 || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="aggtDeprWorth" width="140" label="调整前累计折旧(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span v-if="rows.row.aggtDeprWorth != null">{{ (rows.row.aggtDeprWorth || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="aggtDeprWorthX" width="140" label="累计折旧调整金额(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <input v-if="rows.row.aggtDeprWorth2 != null && rows.row.aggtDeprWorth != null" class="align-right" style="width: 100%" type="number" size="4" @change="((event)=>{changeAggtDeprWorth2(event, rows.row)})"
                                       :value="parseFloat((rows.row.aggtDeprWorth2 - rows.row.aggtDeprWorth).toFixed(2))"/>
                                <input v-else class="align-right" style="width: 100%" type="number" size="4" @change="((event)=>{changeAggtDeprWorth2(event, rows.row)})"/>
                            </template>
                        </el-table-column>
                        <el-table-column prop="aggtDeprWorth2" width="140" label="调整后累计折旧(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.aggtDeprWorth2 != null">{{ rows.row.aggtDeprWorth2.toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="deprMonth" width="100" label="折旧月份" align="right" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="taxOffset" width="100" label="是否抵扣" align="center" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ rows.row.taxOffset ? '是' : '否' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="deprOver" width="100" label="折旧完毕" align="center" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ rows.row.deprOver ? '是' : '否' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="assetType" width="100" label="管理方式" align="center" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ rows.row.assetType == 0 ? '单品式管理' : '批量式管理' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" width="120" label="操作" show-overflow-tooltip fixed="right"
                                         v-if="deprAdjustVoucher.adjustType == 0 || (deprAdjustVoucher.purchReceiptId != null && deprAdjustVoucher.purchReceiptId != -1)">
                            <template slot-scope="scope">
                                <a class="swb-btn-link" v-if="deprAdjustVoucher.purchReceiptId == null || deprAdjustVoucher.purchReceiptId == -1" @click="updateDepr(scope.row, scope.$index)">调整</a>
                                <a class="swb-btn-link" v-if="deviceXId == null && voucherId == null || (voucherId != null && bizVoucherType == null)" @click="deleteDevc(scope.$index)">移除</a>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <template v-if="deprAdjustVoucher.adjustType == 3">
                    <el-table :data="deprAdjustVoucher.itemList" border maxHeight="500">
                        <el-table-column prop="devcInnerCode" width="180" label="资产编号" align="left" fixed show-overflow-tooltip></el-table-column>
                        <el-table-column prop="retailerComFullName" width="180" label="部门全称" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="title" width="180" label="资产描述全称" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="name" width="180" label="名称" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="model" width="150" label="型号" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="fixedSpec" width="150" label="规格" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="tmpNo" width="150" label="系统编号" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="innerDevcBrandName" width="150" label="资产品牌" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="assetKindName" width="150" label="财务类别" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="quantity" width="100" label="数量" align="right" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="theUnit" width="100" label="单位" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="deprMethodCode" width="100" label="折旧算法" align="left" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ deprMethodCodeMap[rows.row.deprMethodCode] }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="taxPrice" width="140" label="调整前进项税额(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ (rows.row.taxPrice || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="taxPrice2" width="140" label="调整后进项税额(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.taxPrice2 != null">{{ (rows.row.taxPrice2 || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="taxRate" width="140" label="调整前进项税率(%)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ (rows.row.taxRate || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="taxRate2" width="140" label="调整后进项税率(%)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.taxRate2 != null">{{ (parseFloat(rows.row.taxRate2) || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ntxPrice" width="140" label="调整前未税金额(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ (rows.row.ntxPrice || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ntxPrice2" width="140" label="调整后未税金额(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.ntxPrice2 != null">{{ (rows.row.ntxPrice2 || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="wtxPrice" width="140" label="调整前含税金额(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ (rows.row.wtxPrice || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="wtxPrice" width="140" label="含税调整金额(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <input class="align-right" style="width: 100%" type="number" size="4" @change="((event)=>{changeWtxPrice2(event, rows.row)})" :value="parseFloat((rows.row.wtxPrice2 - rows.row.wtxPrice).toFixed(2))"
                                       v-if="rows.row.wtxPrice2 != null && rows.row.wtxPrice != null"/>
                                <input class="align-right" style="width: 100%" type="number" size="4" @change="((event)=>{changeWtxPrice2(event, rows.row)})" v-else/>
                            </template>
                        </el-table-column>
                        <el-table-column prop="wtxPrice2" width="140" label="调整后含税金额(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.wtxPrice2 != null">{{ (parseFloat(rows.row.wtxPrice2) || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="orgWorth" width="140" label="调整前资产原值(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span v-if="rows.row.orgWorth != null">{{ (rows.row.orgWorth || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="orgWorth2" width="140" label="调整后资产原值(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.orgWorth2 != null">{{ (rows.row.orgWorth2 || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="netWorth" width="140" label="调整前净值(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span v-if="rows.row.netWorth != null">{{ (rows.row.netWorth || 0).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="netWorth2" width="140" label="调整后净值(元)" align="right" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.netWorth2 != null">{{ rows.row.netWorth2.toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="deprMonth" width="100" label="折旧月份" align="right" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="taxOffset" width="100" label="是否抵扣" align="center" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ rows.row.taxOffset ? '是' : '否' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="deprOver" width="100" label="折旧完毕" align="center" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ rows.row.deprOver ? '是' : '否' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="assetType" width="100" label="管理方式" align="center" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ rows.row.assetType == 0 ? '单品式管理' : '批量式管理' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" width="120" label="操作" show-overflow-tooltip fixed="right"
                                         v-if="deprAdjustVoucher.adjustType == 0 || (deprAdjustVoucher.purchReceiptId != null && deprAdjustVoucher.purchReceiptId != -1)">
                            <template slot-scope="scope">
                                <a class="swb-btn-link" v-if="deprAdjustVoucher.purchReceiptId == null || deprAdjustVoucher.purchReceiptId == -1" @click="updateDepr(scope.row, scope.$index)">调整</a>
                                <a class="swb-btn-link" v-if="deviceXId == null && voucherId == null || (voucherId != null && bizVoucherType == null)" @click="deleteDevc(scope.$index)">移除</a>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {MsgBox, Vue} from '../../app.vues'
    import {calculationOrgWorthDlg, openDeprInfoUpdateDlg} from './showDlg'
    import {openBizUnitOrgTreeDlg} from '../orgStruct/selectDlg'
    import {showDevcSelectDlg} from '../devc/selectDlg'
    import {selectRealAdoptedComDlg} from '../realCom/dialog'

    import userApi from '../../api/user'
    import assetFiscalApi from '../../api/assetFiscal'
    import devcApi from '../../api/devc'
    import fiscalBizApi from '../../api/fiscalBiz'
    import vendorApi from '../../api/vendor';
    //
    import SwbAssetFiscalClearVoucherList from './AssetFiscalClearVoucherList'
    import SwbAssetAdvancedView from '../asset/AssetAdvancedView';
    import merchtComnApi from '../../api/merchtComn'
    import { CtrlParamCodes } from '../../app.const'

    Vue.regist(SwbAssetFiscalClearVoucherList);
    Vue.regist(SwbAssetAdvancedView);

    export default {
        name: 'swb-asset-depr-adjust-voucher-save',
        avlActions: '',
        avlScopes: 'retailer',
        customBreadcrumb: true,
        desc: '调整单 - 制作',
        props: {
            id: {
                type: Number,
                default: null
            },
            receiptId: {
                type: Number,
                default: null
            },
            deviceXId: {
                type: Number,
                default: null
            },
            deviceXIds: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            bizVoucherType: {
                type: Number,
                default: null
            },
            bizVoucherNo: {
                type: String,
                default: null
            },
            // 是否高级调整(非单调)
            mulitiWorth: {
                type: Boolean,
                default: true
            },
            readyAdjust: { // 待调整标识
                type: Boolean,
                default: false
            },
            assetList: {
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        data: function () {
            let validateTitle = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空！'));
                } else {
                    callback();
                }
            };
            return {
                deprAdjustVoucher: {
                    itemList: [],
                    title: null,
                    memo: null,
                    adjustType: 0,
                    orgWorthRevoke: false,
                    settleNeeded: false,
                    settleTaxRate: null,
                    settleTaxOffset: true,
                    settlePeerId: null,
                    settlePeerName: null,
                    sellerInnerCode: null
                },
                comId: null,
                voucherId: null,
                deprMethodCodeMap: getEnumMap("assetDeprMethod", "name2text"),
                adjustAllowed: false,
                //
                autoApply: true,
                autoAuditPass: true,
                retailerBizUnitId: null,
                retailerBizUnitName: null,
                //
                rulesInfo: {
                    title: [{validator: validateTitle, trigger: 'blur'}]
                },
                fiscalTaxMarkList: [],
            }
        },
        created: function () {
            this.voucherId = this.id || null;
            this.deprAdjustVoucher.adjustType = (!Utils.isNoB(this.receiptId) && this.receiptId != -1) ? 3 : this.mulitiWorth ? 0 : 1;
            if (Utils.isTrue(this.readyAdjust)) {
                this.deprAdjustVoucher.adjustType = 1;
            }
            if (this.receiptId != null) {
                this.deprAdjustVoucher.purchReceiptId = this.receiptId;
            }
            if (this.deprAdjustVoucher.adjustType == 1 || this.deprAdjustVoucher.adjustType == 3) {
                this.deprAdjustVoucher.settleNeeded = false;
            } else {
                this.deprAdjustVoucher.settleNeeded = false;
            }
            let ctrlParamData = {paramCode: CtrlParamCodes.DEPR_OVER_ASSET_ORGWORTH_ADJUST_ALLOWED};
            let adjustAllowed = merchtComnApi.getMerchantCtrlParamValueSyncExt(ctrlParamData);
            this.adjustAllowed = adjustAllowed;
            //
            this.getCurrentUserInfo();
            this.getFiscalTaxMarkList();
            //
            if (!Utils.isNoB(this.receiptId)) {
                this.getPurchReceiptItemAssetList(this.deviceXIds);
            }
            if (Utils.isTrue(this.readyAdjust) && !Utils.isNoB(this.assetList)) {
                this.makeAdjustItems();
            }
        },
        methods: {
            getFiscalTaxMarkList: function () {
                let self = this;
                let postData = {};
                postData.disabled = false;
                postData.type = getEnumInfoWith('taxType', "name", "JXS").value;
                //
                let theLoad = MsgBox.loading();
                fiscalBizApi.getFiscalTaxMarkPageList(postData, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        let fiscalTaxMarkList = result.data || [];
                        let y13 = false;
                        if (fiscalTaxMarkList.length > 0) {
                            fiscalTaxMarkList.forEach(function (item) {
                                if (item.rate == 13) {
                                    y13 = true;
                                }
                                item.rate = parseFloat(item.rate).toFixed(2)
                            })
                        }
                        if (!y13) {
                            fiscalTaxMarkList.unshift({
                                rate: 13
                            });
                        }
                        //
                        let deprAdjustVoucher = self.deprAdjustVoucher || {};
                        if (deprAdjustVoucher.purchReceiptId == null || deprAdjustVoucher.purchReceiptId == -1) {
                            deprAdjustVoucher.settleTaxRate = 13;
                            self.deprAdjustVoucher = Utils.merge({}, deprAdjustVoucher);
                        }
                        //
                        self.fiscalTaxMarkList = fiscalTaxMarkList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    if (result.type == 'info') {
                        let data = result.data;
                        self.comId = data.scopeEntity.comId;
                        if (!Utils.isNoB(self.voucherId)) {
                            self.getDeprAdjustVoucher();
                        }
                        if (!Utils.isNoB(self.deviceXId)) {
                            self.getAssetList([self.deviceXId]);
                        } else if (!Utils.isNoB(self.deviceXIds) && self.deviceXIds.length > 0 && Utils.isNoB(self.receiptId)) {
                            self.getAssetList(self.deviceXIds);
                        }
                    } else {
                        MsgBox.error(result.message);
                    }
                });
            },
            getAssetList(deviceXIds) {
                let self = this;
                devcApi.getShopDeviceListByFilter({
                    filterItems: {
                        ids: deviceXIds,
                        useRealQuery: true
                    },
                    pagination: {
                        pageNumber: 1,
                        pageSize: 99999999
                    }
                }, function (result) {
                    if (result.type === "info") {
                        let deprAdjustVoucher = self.deprAdjustVoucher || {};
                        let newItemList = result.data.rows;
                        let resultItemList = self.stuffDevcToItems(deprAdjustVoucher, newItemList);
                        deprAdjustVoucher.itemList = Utils.merge([], resultItemList);
                        self.deprAdjustVoucher = Utils.merge({}, deprAdjustVoucher);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 组装调整单条目
            makeAdjustItems: function () {
                let self = this;
                let deprAdjustVoucher = this.deprAdjustVoucher || {};
                let resultItemList = this.stuffDevcToItems(deprAdjustVoucher, this.assetList);
                let retailerBizUnitId = null;
                let retailerBizUnitName = null;
                let settlePeerId = null;
                let settlePeerName = null;
                let sellerInnerCode = null;
                let accTaxOffset = null;
                for (let i = 0; i < this.assetList.length; i++) {
                    let asset = this.assetList[i];
                    if (Utils.isNoB(settlePeerId)) {
                        settlePeerId = asset.accSellerId;
                        settlePeerName = asset.accSellerName;
                        sellerInnerCode = asset.accSellerInnerCode;
                    }
                    if (Utils.isNoB(accTaxOffset)) {
                        accTaxOffset = asset.accTaxOffset;
                    }
                    if (!Utils.isNoB(settlePeerId)) {
                        break;
                    }
                }
                for (let i = 0; i < resultItemList.length; i++) {
                    let resultItem = resultItemList[i];
                    if (Utils.isTrue(resultItem.taxOffset)) {
                        resultItem.orgWorth2 = parseFloat(resultItem.orgWorth) + parseFloat(resultItem.accNtxAmount || 0);
                    } else {
                        resultItem.orgWorth2 = parseFloat(resultItem.orgWorth) + parseFloat(resultItem.accAmount || 0);
                    }
                    //
                    retailerBizUnitId = resultItem.retailerBizUnitId;
                    retailerBizUnitName = resultItem.retailerBizUnitName;
                }
                let deprInfos = Utils.merge([], resultItemList);
                self.doAssetDeprAdjustTrialCalculation(deprInfos, function (deprAdjustItemList) {
                    let closeFlag = true;
                    for (let j = 0; j < deprAdjustItemList.length; j++) {
                        let deprAdjustItem = deprAdjustItemList[j];
                        if (deprAdjustVoucher.adjustType == 1) {
                            let taxRate = Utils.isNoB(deprAdjustItem.taxRate2) ? deprAdjustItem.taxRate : deprAdjustItem.taxRate2;
                            taxRate = Utils.isNoB(taxRate) ? 0 : taxRate;
                            if (deprAdjustVoucher.settleTaxOffset) {
                                deprAdjustItem.ntxPrice2 = deprAdjustItem.orgWorth2;
                                deprAdjustItem.wtxPrice2 = (parseFloat(deprAdjustItem.orgWorth2) * (1 + (parseFloat(taxRate) * 0.01)));
                            } else {
                                deprAdjustItem.wtxPrice2 = deprAdjustItem.orgWorth2;
                                let ntxPrice2 = (parseFloat(deprAdjustItem.orgWorth2) / (1 + (parseFloat(taxRate) * 0.01)));
                                deprAdjustItem.ntxPrice2 = ntxPrice2.round(2);
                            }
                            deprAdjustItem.taxPrice2 = deprAdjustItem.wtxPrice2 - deprAdjustItem.ntxPrice2;
                        } else {
                            if ((!Utils.isNoB(deprAdjustItem.deprWorth2) && deprAdjustItem.deprWorth2 < 0) || (!Utils.isNoB(deprAdjustItem.aggtDeprWorth2) && deprAdjustItem.aggtDeprWorth2 < 0)) {
                                MsgBox.warning('试算结果近期折旧(元)必须大于等于0,请核对');
                                closeFlag = false;
                                break;
                            }
                        }
                        deprAdjustItem.isChangeFlag = true;
                        //
                        for (let i = 0; i < resultItemList.length; i++) {
                            if (deprAdjustItem.deviceXId == resultItemList[i].deviceXId) {
                                resultItemList[i] = Utils.merge(resultItemList[i], deprAdjustItem);
                            }
                        }
                        deprAdjustVoucher.itemList = Utils.merge([], resultItemList);
                    }
                    //
                    deprAdjustVoucher.retailerBizUnitId = retailerBizUnitId;
                    deprAdjustVoucher.retailerBizUnitName = retailerBizUnitName;
                    deprAdjustVoucher.settlePeerId = settlePeerId;
                    deprAdjustVoucher.settlePeerName = settlePeerName;
                    deprAdjustVoucher.sellerInnerCode = sellerInnerCode;
                    deprAdjustVoucher.settleTaxOffset = Utils.isTrue(accTaxOffset);
                    self.deprAdjustVoucher = Utils.merge({}, deprAdjustVoucher);
                });
            },
            // 验收单来的获取验收单对应的资产信息
            getPurchReceiptItemAssetList: function (deviceXIds) {
                let self = this;
                let singleTheLoad = MsgBox.loading();
                devcApi.getShopDeviceListByFilter({
                    filterItems: {
                        ids: deviceXIds,
                        useRealQuery: true
                    },
                    pagination: {
                        pageNumber: 1,
                        pageSize: 99999999
                    }
                }, function (result) {
                    singleTheLoad.hide();
                    if (result.type === "info") {
                        let newItemList = result.data.rows;
                        //
                        let deprAdjustVoucher = self.deprAdjustVoucher || {};
                        let resultItemList = self.stuffDevcToItems(deprAdjustVoucher, newItemList);
                        deprAdjustVoucher.itemList = Utils.merge([], resultItemList);
                        //
                        let item = newItemList[0] || null;
                        if (!Utils.isNoB(item)) {
                            self.retailerBizUnitId = item.retailerBizUnitId;
                            deprAdjustVoucher.retailerBizUnitId = item.retailerBizUnitId;
                            deprAdjustVoucher.retailerBizUnitName = item.retailerBizUnitName;
                            deprAdjustVoucher.settlePeerId = item.sellerId;
                            deprAdjustVoucher.settlePeerName = item.sellerName;
                            deprAdjustVoucher.sellerInnerCode = item.sellerInnerCode;
                            deprAdjustVoucher.settleTaxOffset = item.taxOffset;
                        }
                        //
                        self.deprAdjustVoucher = Utils.merge({}, deprAdjustVoucher);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            getDeprAdjustVoucher: function () {
                let self = this;
                let postData = {};
                postData.id = self.voucherId;
                assetFiscalApi.getAssetDeprAdjustVoucherInfo(postData, function (result) {
                    if (result.type == "info") {
                        let deprAdjustVoucher = result.data || {};
                        //
                        self.retailerBizUnitId = deprAdjustVoucher.retailerBizUnitId;
                        self.deprAdjustVoucher = Utils.merge({}, deprAdjustVoucher);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取资产的tab
            handleClick: function () {
            },
            // 选择资产
            showDeviceListDlg: function () {
                let self = this;
                let deprAdjustVoucher = self.deprAdjustVoucher;
                let itemList = deprAdjustVoucher.itemList || [];
                let devcIds = itemList.pluck("deviceXId") || [];

                let filter = {};
                filter.scrapped = 0;
                filter.fiscalAcctFlag = 1;
                filter.fiscalAbnormal = false;
                filter.deprOver = false;
                if(deprAdjustVoucher.adjustType == 1 && self.adjustAllowed == true) {
                    filter.deprOver = null;
                }
                // filter.lockBizTypeNotIn = [3, 8, 15];
                filter.fiscalLocked = false;
                filter.retailerComId = self.retailerBizUnitId;
                if (deprAdjustVoucher.adjustType == 3) {
                    filter.wtxAmountGTZero = true;
                }
                //
                let showOrgTree = true;
                //
                if (itemList.length > 0) {
                    showOrgTree = false;
                }
                if (deprAdjustVoucher.settleNeeded) {
                    if (self.retailerBizUnitId == null) {
                        Toast.show('请选择业务单元');
                        return;
                    }
                    if (Utils.isNoB(deprAdjustVoucher.settlePeerId)) {
                        Toast.show('请选择供应商');
                        return;
                    }
                    showOrgTree = false;
                    filter.sellerId = deprAdjustVoucher.settlePeerId;
                }
                if (deprAdjustVoucher.adjustType == 2) {
                    filter.lastDeprWorthX = 0;
                    filter.assetNature = 1;
                }
                let params = {
                    filter: filter,
                    showOrgTree: showOrgTree,
                    bizDepart: true,
                    showMgmt: true,
                    showIncludeSubComs: false,
                    initSelectIds: devcIds,
                    devcBizClolumType: 'TiaoZhengDlg'
                };
                showDevcSelectDlg(params, function (devcList) {
                    let addDevcList = self.stuffDevcToItems(deprAdjustVoucher, devcList);
                    let resultDevcList = itemList.concat(addDevcList);
                    deprAdjustVoucher.itemList = Utils.merge([], resultDevcList);
                    self.deprAdjustVoucher = Utils.merge({}, deprAdjustVoucher);
                });
            },
            stuffDevcToItems(deprAdjustVoucher, devcList) {
                let self = this;
                let itemsList = [];
                let month = new Date().format('yyyyMM');
                if (!Utils.isNoB(devcList)) {
                    //
                    devcList.forEach(function (devc) {
                        //
                        self.retailerBizUnitId = devc.retailerBizUnitId;
                        //
                        let item = {
                            retailerComName: devc.retailerComName,
                            retailerComFullName: devc.retailerComFullName,
                            retailerBizUnitId: devc.retailerBizUnitId,
                            retailerBizUnitName: devc.retailerBizUnitName,
                            deviceXId: devc.id,
                            assetType: devc.assetType,
                            title: devc.title,
                            name: devc.name,
                            model: devc.model,
                            fixedSpec: devc.fixedSpec,
                            modelSpec: devc.modelSpec,
                            theUnit: devc.theUnit,
                            innerCode: devc.devcDefNo,
                            devcInnerCode: devc.innerCode,
                            tmpNo: devc.tmpNo,
                            assetKindId: devc.assetKindId,
                            assetKindName: devc.assetKindName,
                            innerDevcCatId: devc.innerDevcCatId,
                            innerDevcCatFullName: devc.innerDevcCatFullName,
                            innerDevcBrandId: devc.innerDevcBrandId,
                            innerDevcBrandCode: devc.innerDevcBrandCode,
                            innerDevcBrandName: devc.innerDevcBrandName,
                            deprMethodCode: devc.deprMethodCode,
                            rmnWorthRatio: devc.rmnWorthRatio,
                            rmnWorthRatioFlag: false,
                            onsetDate: devc.onsetDate,
                            durableLife: devc.durableLife,
                            cnt1stMonth: devc.cnt1stMonth,
                            deprMonth: Utils.isNoB(devc.lastDeprMonth) ? null : (devc.lastDeprMonth == -1 ? null : devc.lastDeprMonth),
                            deprMonth2: null,
                            deprMonthFlag: false,
                            deprWorth: devc.lastDeprWorth,
                            aggtDeprWorth: Utils.isNoB(devc.aggtDeprWorth) ? null : parseFloat(devc.aggtDeprWorth),
                            aggtDeprWorth2: null,
                            aggtDeprWorthFlag: false,
                            leftMonths: devc.leftMonths,
                            orgWorth: devc.orgWorth,
                            netWorth: devc.netWorth,
                            netWorthFlag: false,
                            quantity: devc.fiscalQuantity,
                            wtxPrice: devc.wtxAmount || 0,
                            ntxPrice: devc.ntxAmount || 0,
                            ntxPrice2: null,
                            ntxPriceFlag: false,
                            taxRate: devc.taxRate,
                            taxRate2: null,
                            taxRateFlag: false,
                            taxPrice: ((devc.wtxAmount || 0) - (devc.ntxAmount || 0)) < 0 ? 0 : ((devc.wtxAmount || 0) - (devc.ntxAmount || 0)),
                            taxOffset: devc.taxOffset,
                            taxPrice2: null,
                            taxPriceFlag: false,
                            execFlag: false,
                            deprOver: devc.deprOver,
                            currentMonthDeprLocked: devc.lastDeprMonth == month,
                            orgworthAdjustAllowed: self.adjustAllowed
                        };
                        if (Utils.isTrue(self.readyAdjust)) {
                            item.accAmount = devc.accPrice;
                            item.accNtxAmount = devc.accNtxPrice;
                        }
                        if (deprAdjustVoucher.orgWorthRevoke) {
                            item.orgWorth2 = 0;
                            item.netWorth2 = 0;
                            item.aggtDeprWorth2 = 0;
                            item.orgWorthFlag = true;
                            item.netWorthFlag = true;
                            item.aggtDeprWorthFlag = true;
                            item.isChangeFlag = true;
                        }
                        itemsList.add(item);
                    });
                }
                return itemsList;
            },
            // 调整
            updateDepr: function (row, index) {
                let self = this;
                let params = {
                    row: row,
                    bizVoucherType: self.bizVoucherType,
                    receiptId: self.receiptId
                };
                openDeprInfoUpdateDlg(params, function (deprInfo, theDlg) {
                    deprInfo.isChangeFlag = true;   // 用于判断是否有未调整的项
                    deprInfo.ntxPrice2 = parseFloat(deprInfo.ntxPrice2) || null;
                    deprInfo.taxPrice2 = parseFloat(deprInfo.taxPrice2) || null;
                    deprInfo.taxRate2 = parseFloat(deprInfo.taxRate2) || null;
                    deprInfo.orgWorth2 = parseFloat(deprInfo.orgWorth2) || null;
                    deprInfo.deprWorth2 = parseFloat(deprInfo.deprWorth2) || null;
                    deprInfo.durableLife2 = deprInfo.durableLife2 || null;
                    deprInfo.onsetDate2 = deprInfo.onsetDate2 || null;
                    deprInfo.rmnWorthRatio2 = parseFloat(deprInfo.rmnWorthRatio2) || null;
                    deprInfo.aggtDeprWorth2 = parseFloat(deprInfo.aggtDeprWorth2) || null;
                    //
                    theDlg.close();
                    let deprAdjustVoucher = self.deprAdjustVoucher || {};
                    let itemList = deprAdjustVoucher.itemList || [];
                    for (let i = 0; i < itemList.length; i++) {
                        if (row.deviceXId == itemList[i].deviceXId) {
                            itemList[i] = Utils.merge({}, deprInfo);
                        }
                    }
                    deprAdjustVoucher.itemList = Utils.merge([], itemList);
                    self.deprAdjustVoucher = Utils.merge({}, deprAdjustVoucher);
                });
            },
            deleteDevc: function (index) {
                let itemList = this.deprAdjustVoucher.itemList || [];
                for (let i = 0; i < itemList.length; i++) {
                    if (i == index) {
                        itemList.splice(i, 1);
                        break;
                    }
                }
                this.deprAdjustVoucher.itemList = Utils.merge([], itemList);
            },
            // 调整单返回
            getDlgResult: function () {
                let self = this;
                let result = {};
                let deprAdjustVoucher = self.deprAdjustVoucher;
                if (Utils.isNoB(deprAdjustVoucher.title)) {
                    result.type = "error";
                    result.message = "【标题】不能为空！";
                    return result;
                } else {
                    let itemList = deprAdjustVoucher.itemList || [];
                    //
                    if (itemList.length <= 0) {
                        result.type = "error";
                        result.message = "请选择资产！";
                        return result;
                    } else {
                        let errMsg = '';
                        let wranMsg = null;
                        let deprOverDevcInnerCodes = [];
                        if (itemList.length > 0) {
                            for (let i = 0; i < itemList.length; i++) {
                                let item = itemList[i];
                                let devcInnerCode = Utils.isNoB(item.devcInnerCode) ? item.tmpNo : item.devcInnerCode;
                                if (!Utils.isTrue(item.isChangeFlag)) {
                                    errMsg = "资产【" + devcInnerCode + "】未调整，请调整！";
                                    break;
                                }
                                if (item.deprOver && item.leftMonths <= 0) {
                                    deprOverDevcInnerCodes.push(devcInnerCode);
                                //    break;
                                }
                                if (item.currentMonthDeprLocked) {
                                    //  errMsg = "资产【" + devcInnerCode + "】已财务锁定，不能进行资产调整！";
                                    //  break;
                                }
                                if (Utils.isTrue(deprAdjustVoucher.settleNeeded)) {
                                    if (Utils.isTrue(item.orgWorthFlag) && parseFloat(item.orgWorth2) < parseFloat(item.orgWorth)) {
                                        errMsg = "资产【" + devcInnerCode + "】需结算只能调增，不可调减！";
                                    } else if (Utils.isTrue(item.wtxPriceFlag) && parseFloat(item.wtxPrice2) < parseFloat(item.wtxPrice)) {
                                        errMsg = "资产【" + devcInnerCode + "】需结算只能调增，不可调减！";
                                    }
                                }
                            }
                        }
                        if (!Utils.isNoB(errMsg)) {
                            result.type = "error";
                            result.message = errMsg;
                            return result;
                        }
                        //
                        for (let i = 0; i < itemList.length; i++) {
                            let item = itemList[i];
                            item.bizVoucherType = self.bizVoucherType;
                            item.bizVoucherNo = self.bizVoucherNo;
                        }
                        deprAdjustVoucher.itemList = itemList;
                        if (itemList.length > 500) {
                            result.type = "error";
                            result.message = "【资产】支持最大单据级条目为500条！现" + itemList.length + "条！";
                            return result;
                        }
                        deprAdjustVoucher.autoApply = self.autoApply;
                        deprAdjustVoucher.autoAuditPass = self.autoAuditPass;
                        deprAdjustVoucher.retailerBizUnitId = self.retailerBizUnitId;
                        //
                        if(deprOverDevcInnerCodes.length > 0) {
                            // deprOverDevcInnerCodes数据转字符串逗号分隔
                            let devcInnerCodes = deprOverDevcInnerCodes.join("<br/>");
                            wranMsg = "价值调整中包含资产【" + devcInnerCodes + "】已折旧完毕，确认继续调整吗！";
                        }
                        if (!Utils.isNoB(wranMsg)) {
                            result.type = "warn";
                            result.message = wranMsg;
                        } else {
                            result.type = "info";
                        }
                        result.data = deprAdjustVoucher;
                        return result;
                    }
                }
            },
            calculationOrgWorthDlg(row) {
                let self = this;
                let deprAdjustVoucher = self.deprAdjustVoucher;
                calculationOrgWorthDlg(deprAdjustVoucher.settleTaxRate, function (valueAsNumber, wtxPrice) {
                    let itemList = deprAdjustVoucher.itemList || [];
                    let warnMsg = null;
                    for (let j = 0; j < itemList.length; j++) {
                        let item = itemList[j];
                        if (item.deviceXId == row.deviceXId) {
                            item.orgWorth2 = item.orgWorth + valueAsNumber;
                            if (item.orgWorth2 <= 0) {
                                item.orgWorth2 = item.orgWorth;
                                item.isChangeFlag = false;
                                warnMsg = '试算结果原值(元)必须大于0,请核对';
                                break;
                            }
                            if (valueAsNumber != 0) {
                                item.isChangeFlag = true;
                            } else {
                                item.isChangeFlag = false;
                            }
                            // 暂时使用，作为需结算的含税价
                            item.wtxPrice = wtxPrice;
                            item.wtxPrice2 = null;
                            itemList[j] = Utils.merge({}, item);
                        }
                    }
                    deprAdjustVoucher.itemList = Utils.merge([], itemList);
                    self.deprAdjustVoucher = Utils.merge({}, deprAdjustVoucher);
                    //
                    if (warnMsg != null) {
                        MsgBox.warning(warnMsg);
                        return;
                    }
                    self.hancleAdjustAmount();
                    self.doShiSuan(true);
                });
            },
            batchOrgWorthUpdate() {
                let self = this;
                let deprAdjustVoucher = self.deprAdjustVoucher;
                let adjustType = deprAdjustVoucher.adjustType;
                let itemList = deprAdjustVoucher.itemList || [];
                let totalOrgWorth = 0;
                let totalAggtDeprWorth = 0;
                let totalDeprWorth = 0;
                itemList.forEach(function (item) {
                    totalOrgWorth += item.orgWorth;
                    totalAggtDeprWorth += item.aggtDeprWorth || 0;
                    totalDeprWorth += item.deprWorth || 0;
                });
                if (itemList.length == 0) {
                    Toast.show('请选择资产');
                    return;
                }
                let receiptId = this.receiptId;
                let theDlg = Vue.$showDialog({
                    title: adjustType == 1 ? '批量分摊-调整原值' : '批量分摊-调整累计折旧',
                    showCloseBtn: true,
                    width: 600,
                    height: 550,
                    template: '<div class="simple-form">' +
                        '   <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label>资产条目数</label>' +
                        '        </div>' +
                        '        <div class="form-value width-1-5x">' +
                        '            <span>{{deviceSize}}</span>' +
                        '        </div>' +
                        '    </div>' +
                        '   <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label>原值合计(元)</label>' +
                        '        </div>' +
                        '        <div class="form-value width-1-5x">' +
                        '            <span>{{totalOrgWorth.toFixed(2)}}</span>' +
                        '        </div>' +
                        '    </div>' +
                        '   <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label>累计折旧合计(元)</label>' +
                        '        </div>' +
                        '        <div class="form-value width-1-5x">' +
                        '            <span>{{totalAggtDeprWorth.toFixed(2)}}</span>' +
                        '        </div>' +
                        '    </div>' +
                        '   <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label>调整方向</label>' +
                        '        </div>' +
                        '        <div class="form-value width-1-5x">' +
                        '            <el-radio-group v-model="upType" @change="upChange" :disabled="disabledUpType">' +
                        '                <el-radio :label="1">调增</el-radio>' +
                        '                <el-radio :label="-1">调减</el-radio>' +
                        '            </el-radio-group>' +
                        '            <div class="input-tip error">谨慎调减</div>' +
                        '        </div>' +
                        '    </div>' +
                        '   <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label>分摊比例依据</label>' +
                        '        </div>' +
                        '        <div class="form-value width-1-5x">' +
                        '            <span>原值</span>' +
                        '        </div>' +
                        '    </div>' +
                        '   <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label class="required">调整金额合计(元)</label>' +
                        '        </div>' +
                        '        <div class="form-value width-1-5x">' +
                        '            <el-input class="align-right" type="number" size="4" v-model="upPrice" @change="upChange"></el-input>' +
                        '        </div>' +
                        '    </div>' +
                        '   <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label>{{adjustType == 1 ? "调整后原值合计(元)" : "调整后累计折旧合计(元)"}}</label>' +
                        '        </div>' +
                        '        <div class="form-value width-1-5x">' +
                        '            <span v-if="adjustAmount != null">{{adjustAmount.toFixed(2)}}</span>' +
                        '        </div>' +
                        '    </div>' +
                        '</div>',
                    data: {
                        deviceSize: itemList.length,
                        totalOrgWorth: totalOrgWorth,
                        totalAggtDeprWorth: totalAggtDeprWorth,
                        adjustType: adjustType,
                        upType: 1,
                        upPrice: null,
                        adjustAmount: null,
                        disabledUpType: deprAdjustVoucher.settleNeeded && receiptId == null
                    },
                    methods: {
                        upChange() {
                            if (Utils.isMoneyStr(this.upPrice) && this.upPrice > 0) {
                                let totalWorth = this.adjustType == 1 ? this.totalOrgWorth : this.totalAggtDeprWorth;
                                this.adjustAmount = totalWorth + this.upPrice * this.upType;
                            } else {
                                this.adjustAmount = null;
                            }
                        }
                    },
                    okClicked: function () {
                        let adjustAmount = this.adjustAmount;
                        let upPrice = this.upPrice;
                        let upType = this.upType;
                        let adjustType = this.adjustType;
                        if (adjustAmount == null) {
                            Toast.show('请输入正确的调整金额');
                            return false;
                        } else {
                            if (adjustType == 2) {
                                // 新总当期折旧 = 老当期折旧 + （新累计折旧 - 老累计折旧）
                                adjustAmount = totalDeprWorth + (adjustAmount - totalAggtDeprWorth);
                            }
                            for (let i = 0; i < itemList.length; i++) {
                                let item = itemList[i];
                                let orgWorth = item.orgWorth;
                                // 在原总原值中占比
                                let bili = orgWorth / totalOrgWorth;
                                //
                                if (adjustType == 1) {
                                    item.orgWorth2 = (item.orgWorth || 0) + parseFloat((upPrice * bili).toFixed(2)) * upType;
                                } else {
                                    item.deprWorth2 = (item.deprWorth || 0) + parseFloat((upPrice * bili).toFixed(2)) * upType;
                                }
                                item.wtxPrice2 = null;
                                item.ntxPrice2 = null;
                                item.taxPrice2 = null;
                                item.taxRateFlag = false;
                                item.wtxPriceFlag = false;
                                item.ntxPriceFlag = false;
                                if (deprAdjustVoucher.settleNeeded) {
                                    item.taxRate2 = parseFloat(deprAdjustVoucher.settleTaxRate)
                                }
                            }
                            let deprInfos = Utils.merge([], itemList);
                            let orgAmount = 0;
                            for (let i = 0; i < deprInfos.length; i++) {
                                let deprInfo = deprInfos[i];
                                if (i != deprInfos.length - 1) {
                                    if (adjustType == 1) {
                                        orgAmount += parseFloat(deprInfo.orgWorth2);
                                    } else {
                                        orgAmount += parseFloat(deprInfo.deprWorth2);
                                    }
                                } else {
                                    if (adjustType == 1) {
                                        deprInfo.orgWorth2 = adjustAmount - orgAmount;
                                    } else {
                                        deprInfo.deprWorth2 = adjustAmount - orgAmount;
                                    }
                                }
                                if (adjustType == 1) {
                                    if (parseFloat(deprInfo.orgWorth2) <= 0) {
                                        MsgBox.warning('试算结果原值(元)必须大于0,请核对');
                                        return false;
                                    }
                                } else {
                                    if (parseFloat(deprInfo.deprWorth2) < 0) {
                                        MsgBox.warning('试算结果近期折旧(元)必须大于等于0,请核对');
                                        return false;
                                    }
                                }
                            }
                            self.doAssetDeprAdjustTrialCalculation(deprInfos, function (deprAdjustItemList) {
                                let closeFlag = true;
                                for (let j = 0; j < deprAdjustItemList.length; j++) {
                                    let deprAdjustItem = deprAdjustItemList[j];
                                    if (adjustType == 1) {
                                        let taxRate = Utils.isNoB(deprAdjustItem.taxRate2) ? deprAdjustItem.taxRate : deprAdjustItem.taxRate2;
                                        taxRate = Utils.isNoB(taxRate) ? 0 : taxRate;
                                        if (deprAdjustVoucher.settleTaxOffset) {
                                            deprAdjustItem.ntxPrice2 = deprAdjustItem.orgWorth2;
                                            deprAdjustItem.wtxPrice2 = (parseFloat(deprAdjustItem.orgWorth2) * (1 + (parseFloat(taxRate) * 0.01)));
                                        } else {
                                            deprAdjustItem.wtxPrice2 = deprAdjustItem.orgWorth2;
                                            let ntxPrice2 = (parseFloat(deprAdjustItem.orgWorth2) / (1 + (parseFloat(taxRate) * 0.01)));
                                            deprAdjustItem.ntxPrice2 = ntxPrice2.round(2);
                                        }
                                        deprAdjustItem.taxPrice2 = deprAdjustItem.wtxPrice2 - deprAdjustItem.ntxPrice2;
                                    } else {
                                        if ((!Utils.isNoB(deprAdjustItem.deprWorth2) && deprAdjustItem.deprWorth2 < 0) || (!Utils.isNoB(deprAdjustItem.aggtDeprWorth2) && deprAdjustItem.aggtDeprWorth2 < 0)) {
                                            MsgBox.warning('试算结果近期折旧(元)必须大于等于0,请核对');
                                            closeFlag = false;
                                            break;
                                        }
                                    }
                                    deprAdjustItem.isChangeFlag = true;
                                    //
                                    for (let i = 0; i < itemList.length; i++) {
                                        if (deprAdjustItem.deviceXId == itemList[i].deviceXId) {
                                            itemList[i] = Utils.merge(itemList[i], deprAdjustItem);
                                        }
                                    }
                                    deprAdjustVoucher.itemList = Utils.merge([], itemList);
                                    self.deprAdjustVoucher = Utils.merge({}, deprAdjustVoucher);
                                }
                                if (closeFlag) {
                                    theDlg.close();
                                }
                            });
                            return false;
                        }
                    }
                });
            },
            // 批量调整含税金额
            batchWtxPriceUpdate() {
                let self = this;
                let deprAdjustVoucher = self.deprAdjustVoucher;
                let itemList = deprAdjustVoucher.itemList || [];
                let totalWtxPrice = 0;
                itemList.forEach(function (item) {
                    totalWtxPrice += item.wtxPrice;
                });
                if (itemList.length == 0) {
                    Toast.show('请选择资产');
                    return;
                }
                let receiptId = this.receiptId;
                let theDlg = Vue.$showDialog({
                    title: '批量分摊-调整含税金额',
                    showCloseBtn: true,
                    width: 600,
                    height: 550,
                    template: '<div class="simple-form">' +
                        '   <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label>资产条目数</label>' +
                        '        </div>' +
                        '        <div class="form-value width-1-5x">' +
                        '            <span>{{deviceSize}}</span>' +
                        '        </div>' +
                        '    </div>' +
                        '   <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label>含税合计(元)</label>' +
                        '        </div>' +
                        '        <div class="form-value width-1-5x">' +
                        '            <span>{{totalWtxPrice.toFixed(2)}}</span>' +
                        '        </div>' +
                        '    </div>' +
                        '   <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label>调整方向</label>' +
                        '        </div>' +
                        '        <div class="form-value width-1-5x">' +
                        '            <el-radio-group v-model="upType" @change="upChange" :disabled="disabledUpType">' +
                        '                <el-radio :label="1">调增</el-radio>' +
                        '                <el-radio :label="-1">调减</el-radio>' +
                        '            </el-radio-group>' +
                        '            <div class="input-tip error">谨慎调减</div>' +
                        '        </div>' +
                        '    </div>' +
                        '   <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label>分摊比例依据</label>' +
                        '        </div>' +
                        '        <div class="form-value width-1-5x">' +
                        '            <span>含税价</span>' +
                        '        </div>' +
                        '    </div>' +
                        '   <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label class="required">调整金额合计(元)</label>' +
                        '        </div>' +
                        '        <div class="form-value width-1-5x">' +
                        '            <el-input class="align-right" type="number" size="4" v-model="upPrice" @change="upChange"></el-input>' +
                        '        </div>' +
                        '    </div>' +
                        '   <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label>调整后含税合计(元)</label>' +
                        '        </div>' +
                        '        <div class="form-value width-1-5x">' +
                        '            <span v-if="adjustAmount != null">{{adjustAmount.toFixed(2)}}</span>' +
                        '        </div>' +
                        '    </div>' +
                        '</div>',
                    data: {
                        deviceSize: itemList.length,
                        totalWtxPrice: totalWtxPrice,
                        upType: 1,
                        upPrice: null,
                        adjustAmount: null,
                        disabledUpType: true // deprAdjustVoucher.settleNeeded && (receiptId == null || receiptId == -1)
                    },
                    methods: {
                        upChange() {
                            if (Utils.isMoneyStr(this.upPrice) && this.upPrice > 0) {
                                this.adjustAmount = this.totalWtxPrice + this.upPrice * this.upType;
                            } else {
                                this.adjustAmount = null;
                            }
                        }
                    },
                    okClicked: function () {
                        let adjustAmount = this.adjustAmount;
                        let upPrice = this.upPrice;
                        let upType = this.upType;
                        if (adjustAmount == null) {
                            Toast.show('请输入正确的调整金额');
                            return false;
                        } else {
                            for (let i = 0; i < itemList.length; i++) {
                                let item = itemList[i];
                                let wtxPrice = item.wtxPrice;
                                // 在原总含税价中占比
                                let bili = wtxPrice / totalWtxPrice;
                                //
                                item.wtxPrice2 = (item.wtxPrice || 0) + parseFloat((upPrice * bili).toFixed(2)) * upType;
                                item.wtxPriceFlag = true;
                                if (deprAdjustVoucher.settleNeeded) {
                                    item.taxRate2 = parseFloat(deprAdjustVoucher.settleTaxRate)
                                }
                                item.ntxPrice2 = null;
                                item.taxPrice2 = null;
                                item.taxPriceFlag = false;
                                item.ntxPriceFlag = false;
                            }
                            let deprInfos = Utils.merge([], itemList);
                            let orgAmount = 0;
                            for (let i = 0; i < deprInfos.length; i++) {
                                let deprInfo = deprInfos[i];
                                if (i != deprInfos.length - 1) {
                                    orgAmount += parseFloat(deprInfo.wtxPrice2);
                                } else {
                                    deprInfo.wtxPrice2 = adjustAmount - orgAmount;
                                }
                                if (parseFloat(deprInfo.wtxPrice2) <= 0) {
                                    MsgBox.warning('试算结果含税金额(元)必须大于0,请核对');
                                    return false;
                                }
                            }
                            self.doAssetDeprAdjustTrialCalculation(deprInfos, function (deprAdjustItemList) {
                                let closeFlag = true;
                                for (let j = 0; j < deprAdjustItemList.length; j++) {
                                    let deprAdjustItem = deprAdjustItemList[j];
                                    deprAdjustItem.isChangeFlag = true;
                                    //
                                    for (let i = 0; i < itemList.length; i++) {
                                        if (deprAdjustItem.deviceXId == itemList[i].deviceXId) {
                                            itemList[i] = Utils.merge(itemList[i], deprAdjustItem);
                                        }
                                    }
                                    deprAdjustVoucher.itemList = Utils.merge([], itemList);
                                    self.deprAdjustVoucher = Utils.merge({}, deprAdjustVoucher);
                                }
                                if (closeFlag) {
                                    theDlg.close();
                                }
                            });
                            return false;
                        }
                    }
                });
            },
            doAssetDeprAdjustTrialCalculation(deprInfos, callback) {
                let theLoad = MsgBox.loading();
                assetFiscalApi.doAssetDeprAdjustTrialCalculationBatch(deprInfos, function (result) {
                    theLoad.close();
                    if (result.type == "info") {
                        callback(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            doShiSuan(settleWtxPrice) {
                let self = this;
                let deprAdjustVoucher = self.deprAdjustVoucher;
                let itemList = deprAdjustVoucher.itemList || [];
                //
                let deprInfos = [];
                for (let i = 0; i < itemList.length; i++) {
                    let item = itemList[i];
                    item.ntxPrice2 = null;
                    item.taxPrice2 = null;
                    item.ntxPriceFlag = false;
                    item.taxPriceFlag = false;
                    if (deprAdjustVoucher.settleNeeded) {
                        item.taxRate2 = parseFloat(deprAdjustVoucher.settleTaxRate)
                    }
                    if (item.isChangeFlag) {
                        deprInfos.push(item);
                    }
                }
                //
                self.doAssetDeprAdjustTrialCalculation(deprInfos, function (deprAdjustItemList) {
                    for (let j = 0; j < deprAdjustItemList.length; j++) {
                        let deprAdjustItem = deprAdjustItemList[j];
                        //
                        for (let i = 0; i < itemList.length; i++) {
                            if (deprAdjustItem.deviceXId == itemList[i].deviceXId) {
                                if (settleWtxPrice != null && settleWtxPrice == true && deprAdjustItem.wtxPrice != null) {
                                    deprAdjustItem.wtxPrice2 = deprAdjustItem.wtxPrice;
                                    deprAdjustItem.wtxPrice = null;
                                }
                                itemList[i] = Utils.merge(itemList[i], deprAdjustItem);
                            }
                        }
                        deprAdjustVoucher.itemList = Utils.merge([], itemList);
                        self.deprAdjustVoucher = Utils.merge({}, deprAdjustVoucher);
                    }
                });
            },
            selectBizUnit: function () {
                let self = this;
                let dlgConfig = {
                    isSelectThisLevel: true,
                    enableSearch: true,
                    isRadio: true,
                    title: '零售商机构-选择'
                };
                openBizUnitOrgTreeDlg(dlgConfig, function (result, theDlg) {
                    theDlg.close();
                    let deprAdjustVoucher = self.deprAdjustVoucher;
                    self.retailerBizUnitId = result.bizUnitId;
                    deprAdjustVoucher.retailerBizUnitId = result.bizUnitId;
                    deprAdjustVoucher.retailerBizUnitName = result.bizUnitName;
                    deprAdjustVoucher.itemList = [];
                    self.deprAdjustVoucher = Utils.merge({}, deprAdjustVoucher);
                });
            },
            changeAdjustType() {
                let deprAdjustVoucher = this.deprAdjustVoucher;
                if (deprAdjustVoucher.adjustType == 1 || deprAdjustVoucher.adjustType == 3) {
                    deprAdjustVoucher.settleNeeded = false;
                } else {
                    deprAdjustVoucher.settleNeeded = false;
                }
                deprAdjustVoucher.orgWorthRevoke = false;
                deprAdjustVoucher.itemList = [];
                this.deprAdjustVoucher = Utils.merge({}, deprAdjustVoucher);
            },
            changeOrgWorthRevoke() {
                let deprAdjustVoucher = this.deprAdjustVoucher;
                deprAdjustVoucher.settleNeeded = false;
                deprAdjustVoucher.itemList = [];
                this.deprAdjustVoucher = Utils.merge({}, deprAdjustVoucher);
            },
            changeSettleNeeded() {

            },
            changeSettleTaxRate() {
                let deprAdjustVoucher = this.deprAdjustVoucher;
                let itemList = deprAdjustVoucher.itemList || [];
                //
                itemList.forEach(function (item) {
                    item.taxRate2 = parseFloat(deprAdjustVoucher.settleTaxRate);
                });
                //
                deprAdjustVoucher.itemList = Utils.merge([], itemList);
                this.deprAdjustVoucher = Utils.merge({}, deprAdjustVoucher);
                //
                this.doShiSuan();
            },
            changeSettleTaxOffset() {

            },
            selectSeller() {
                let self = this;
                // 选择入选供方公司
                selectRealAdoptedComDlg({
                    checkBox: false,
                    filter: {
                        peerMerchantType: getEnumInfoWith('merchantType', 'name', 'Vendor').value,
                        adoptedType: 1 // 准入类型：入选
                    }
                }, function (realAdoptedCom, theDlg) {
                    theDlg.close();
                    realAdoptedCom = realAdoptedCom || {};
                    //
                    let deprAdjustVoucher = self.deprAdjustVoucher;
                    deprAdjustVoucher.settleAdoptedComId = realAdoptedCom.id;
                    deprAdjustVoucher.settlePeerRealId = realAdoptedCom.peerRealMerchantId;
                    deprAdjustVoucher.settlePeerType = realAdoptedCom.peerMerchantType;
                    deprAdjustVoucher.sellerInnerCode = realAdoptedCom.peerInnerCode;
                    // 获取对应的供应商分管商户 sellerId sellerName
                    self.getVendor(realAdoptedCom.peerRealMerchantId, realAdoptedCom.peerRealComId, function (vendor) {
                        deprAdjustVoucher.settlePeerId = vendor.id;
                        deprAdjustVoucher.settlePeerName = vendor.name;
                        self.deprAdjustVoucher = Utils.merge({}, deprAdjustVoucher);
                    });
                });
            },
            getVendor: function (realId, realComId, callback) {
                let postData = {};
                postData.pagination = {
                    pageSize: 1,
                    pageNumber: 1
                };
                let filterItems = {};
                filterItems.realId = realId;
                filterItems.realComId = realComId;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = [];
                postData.sortItems = {};
                //
                let theLoad = MsgBox.loading();
                vendorApi.getMerchantDtoList(postData, function (result) {
                    theLoad.hide();
                    if (result.type == "info") {
                        let rows = result.data.rows;
                        if (Utils.isNoB(rows) || rows.length == 0) {
                            MsgBox.warning('无法获取供应商');
                        } else {
                            callback(rows[0]);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            hancleAdjustAmount() {
                let adjustAmount = 0;
                let deprAdjustVoucher = this.deprAdjustVoucher;
                let itemList = deprAdjustVoucher.itemList || [];
                if (deprAdjustVoucher.settleNeeded) {
                    itemList.forEach(function (item) {
                        adjustAmount += item.orgWorth2 - item.orgWorth;
                    });
                    deprAdjustVoucher.adjustAmount = adjustAmount;
                    this.deprAdjustVoucher = Utils.merge({}, deprAdjustVoucher);
                }
            },
            changeWtxPrice2(event, row) {
                let deprAdjustVoucher = this.deprAdjustVoucher;
                let itemList = deprAdjustVoucher.itemList || [];
                let valueAsNumber = event.target.valueAsNumber || 0;
                if (Utils.isTrue(deprAdjustVoucher.settleNeeded) && parseFloat(valueAsNumber) < 0) {
                    MsgBox.warning("需结算的只能调增，不可调减");
                    return;
                }
                let warnMsg = null;
                for (let j = 0; j < itemList.length; j++) {
                    let item = itemList[j];
                    if (item.deviceXId == row.deviceXId) {
                        item.wtxPrice2 = item.wtxPrice + valueAsNumber;
                        if (item.wtxPrice2 <= 0) {
                            item.wtxPrice2 = item.wtxPrice;
                            item.isChangeFlag = false;
                            warnMsg = '试算结果原值(元)必须大于0,请核对';
                            break;
                        }
                        if (valueAsNumber != 0) {
                            item.isChangeFlag = true;
                        } else {
                            item.isChangeFlag = false;
                        }
                        itemList[j] = Utils.merge({}, item);
                    }
                }
                deprAdjustVoucher.itemList = Utils.merge([], itemList);
                this.deprAdjustVoucher = Utils.merge({}, deprAdjustVoucher);
                //
                if (warnMsg != null) {
                    MsgBox.warning(warnMsg);
                    return;
                }
                this.doShiSuan();
            },
            changeOrgWorth2(event, row) {
                let deprAdjustVoucher = this.deprAdjustVoucher;
                let itemList = deprAdjustVoucher.itemList || [];
                let valueAsNumber = event.target.valueAsNumber || 0;
                if (Utils.isTrue(deprAdjustVoucher.settleNeeded) && parseFloat(valueAsNumber) < 0) {
                    MsgBox.warning("需结算的只能调增，不可调减");
                    return;
                }
                let warnMsg = null;
                for (let j = 0; j < itemList.length; j++) {
                    let item = itemList[j];
                    if (item.deviceXId == row.deviceXId) {
                        item.orgWorth2 = item.orgWorth + valueAsNumber;
                        item.netWorth2 = null;
                        item.ntxPrice2 = null;
                        item.wtxPrice2 = null;
                        item.aggtDeprWorth2 = null;

                        item.netWorthFlag = false;
                        item.ntxPriceFlag = false;
                        item.wtxPriceFlag = false;
                        item.aggtDeprWorthFlag = false;
                        if (item.orgWorth2 <= 0) {
                            item.orgWorth2 = item.orgWorth;
                            item.isChangeFlag = false;
                            warnMsg = '试算结果原值(元)必须大于0,请核对';
                            break;
                        }
                        if (valueAsNumber != 0) {
                            item.isChangeFlag = true;
                        } else {
                            item.isChangeFlag = false;
                        }
                        itemList[j] = Utils.merge({}, item);
                    }
                }
                deprAdjustVoucher.itemList = Utils.merge([], itemList);
                this.deprAdjustVoucher = Utils.merge({}, deprAdjustVoucher);
                //
                if (warnMsg != null) {
                    MsgBox.warning(warnMsg);
                    return;
                }
                this.hancleAdjustAmount();
                this.doShiSuan();
            },
            changeAggtDeprWorth2(event, row) {
                let deprAdjustVoucher = this.deprAdjustVoucher;
                let itemList = deprAdjustVoucher.itemList || [];
                let valueAsNumber = event.target.valueAsNumber || 0;
                let warnMsg = null;
                for (let j = 0; j < itemList.length; j++) {
                    let item = itemList[j];
                    if (item.deviceXId == row.deviceXId) {
                        let deprWorth = item.deprWorth;
                        if (deprWorth == null) {
                            item.isChangeFlag = false;
                            warnMsg = '累计折旧调整，不支持外部系统折旧结果在SWB内调整！';
                            break;
                        }
                        deprWorth = deprWorth.round(2);
                        item.deprWorth2 = deprWorth + valueAsNumber;
                        if (item.deprWorth2 < 0) {
                            item.deprWorth2 = item.deprWorth;
                            item.isChangeFlag = false;
                            warnMsg = '试算结果近期折旧(元)必须大于等于0,请核对';
                            break;
                        }
                        if (valueAsNumber != 0) {
                            item.isChangeFlag = true;
                        } else {
                            item.aggtDeprWorth2 = item.aggtDeprWorth;
                            item.netWorth2 = item.netWorth;
                            item.isChangeFlag = false;
                        }
                        itemList[j] = Utils.merge({}, item);
                    }
                }
                deprAdjustVoucher.itemList = Utils.merge([], itemList);
                this.deprAdjustVoucher = Utils.merge({}, deprAdjustVoucher);
                if (warnMsg != null) {
                    MsgBox.warning(warnMsg);
                    return;
                }
                this.doShiSuan();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/assetFiscal/AssetDeprAdjustVoucherSave.vue